module.exports = require("jaeger-client/dist/src/reporters/http_sender");